// extracted by mini-css-extract-plugin
export var button = "_cc-2";
export var iconWrapper = "_cc-0";
export var investigatingIcon = "_cc-1";